import React from 'react';
import Loadable from 'react-loadable';

import { UFOHold } from '@townsquare/gemini/ufo-hold';

export const NotificationsBell = Loadable({
  loader: () => import(/* webpackChunkName: "Notifications" */ './Notifications'),
  loading: () => <UFOHold name="loading-notifications-bell" />,
});
